import React, { useState } from 'react';
import { Dialog } from '@mui/material';
import TextEditor from './TextEditor';

const FileEditor = ({ file, onClose, onSave }) => {
  const [isMaximized, setIsMaximized] = useState(false);

  const handleMaximize = () => {
    setIsMaximized(!isMaximized);
  };

  return (
    <Dialog
      open={true}
      onClose={() => onClose({ shouldConfirm: false })}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          height: isMaximized ? '100vh' : '80vh',
          maxHeight: isMaximized ? '100vh' : '80vh',
          m: isMaximized ? 0 : 2
        }
            }}
          >
      <TextEditor
        file={file}
        onClose={onClose}
        onSave={onSave}
        onMinimize={() => onClose({ shouldConfirm: false, minimize: true })}
        onMaximize={handleMaximize}
        isMaximized={isMaximized}
      />
    </Dialog>
  );
};

export default FileEditor; 